import axios from '@axios'

export default {
  namespaced: true,
  state: {
    cards: [],
    cardsLoaded: false,
    selectedCreditCard: null,
    cardForRemove: null,
    billingAddressLoaded: false,
    billingAddress: {
      'country': '',
      'address_line_1': '',
      'address_line_2': '',
      'city': '',
      'state': '',
      'zip': '',
    },
  },
  getters: {
    getCardsList: state => state.cards,
    getIsCardsAlreadyLoaded: state => state.cardsLoaded,
    getIsBillingAddressAlreadyLoaded: state => state.billingAddressLoaded,
    getSelectedCreditCard: state => state.selectedCreditCard,
    getSelectedCardInfo: state => {
      return state.cards.find(card => card.id == state.selectedCreditCard)
    },
    getCardForRemove: state => state.cardForRemove,
    getBillingAddressData: state => state.billingAddress,
  },
  mutations: {
    SET_CREDIT_CARDS_LIST: (state, data) => {
      state.cards = data
    },
    SET_CARDS_LOADED_STATUS: (state, val) => {
      state.cardsLoaded = val
    },
    SET_SELECTED_CREDIT_CARD: (state, val) => {
      state.selectedCreditCard = val
    },
    SET_CARD_FOR_REMOVE: (state, val) => {
      state.cardForRemove = val
    },
    SET_BILLING_ADDRESS: (state, data) => {
      state.billingAddress = data
    },
    SET_BILLING_ADDRESS_LOADED_STATUS: (state, val) => {
      state.billingAddressLoaded = val
    },
  },
  actions: {
    fetchUserCards({ commit, rootGetters }) {
      return new Promise((resolve, reject) => {
        axios
          .get('cards', {
            params: {
              sortBy: 'created_at',
            },
          })
          .then(response => {
            const paymentType = rootGetters['paymentSettings/getPaymentType']
            const filteredCards = response.data.data.filter(card =>
              card.gateway === paymentType
            )

            commit('SET_CREDIT_CARDS_LIST', filteredCards)
            resolve(response)
          })
          .catch(error => reject(error))
      })
    },
    async deleteCreditCard(store, id) {
      try {
        await axios.delete(`cards/${id}`)
      } catch (error) {
        return error
      }
    },
    async createNewCreditCard(store, queryParams) {
      try {
        const response = await axios.post('/cards', queryParams)
        store.commit('SET_SELECTED_CREDIT_CARD', response.data.data.id)
      } catch (error) {
        return error
      }
    },
    async replaceCreditCard(store, payload) {
      try {
        await axios.post(`/cards/${payload.id}/replace`, payload.params)
      } catch (error) {
        return error
      }
    },
    async changeDefaultCard(store, queryParams) {
      try {
        await axios.post(`/cards/${queryParams.card_id}/change-default`, queryParams)
      } catch (error) {
        throw new Error(error)
      }
    },
    async loadCards({ getters, dispatch, commit }) {
      if (!getters.getIsCardsAlreadyLoaded) {
        await dispatch('fetchUserCards')
        commit('SET_CARDS_LOADED_STATUS', true)
      }
      if (!getters.getIsBillingAddressAlreadyLoaded) {
        await dispatch('fetchBillingAddress')
        commit('SET_BILLING_ADDRESS_LOADED_STATUS', true)
      }
    },
    fetchBillingAddress({ commit }) {
      return new Promise((resolve, reject) => {
        axios
          .get('user-billing-address')
          .then(response => {
            commit('SET_BILLING_ADDRESS', response.data.data)
            resolve(response)
          })
          .catch(error => reject(error))
      })
    },
    async loadBillingAddress({ getters, dispatch, commit }) {
      if (!getters.getIsBillingAddressAlreadyLoaded) {
        await dispatch('fetchBillingAddress')
        commit('SET_BILLING_ADDRESS_LOADED_STATUS', true)
      }
    }
  },
}